[
  {
    "image": "grafica-partitions",
    "title": "Графічний дизайн і безкомпромісна якість у колекції перегородок Grafica.",
    "description": "У цій колекції ми створили різноманіття дизайну стулок і оснастили міжкімнатні перегородки бездоганною якістю механізмів. Особливість колекції - плавність ковзання, комфорт і дизайн.",
    "date": "15.08.2024"
  },
  {
    "image": "new-partitions",
    "title": "Рейкова перегородка – це щось новеньке!",
    "description": "Якщо перед вами стоїть завдання зонувати простір, зверніть увагу на ультрасучасне рішення – рейкові перегородки. З їх допомогою можна легко і елегантно обіграти інтер'єр, а наша унікальна розробка поворотного механізму дозволить створювати різні сценарії освітлення навіть у невеликих приміщеннях.",
    "date": "21.08.2024"
  },
  {
    "image": "decorative-slats",
    "title": "Декоративна рейка – така проста і така функціональна.",
    "description": "Ще вчора про цю крихітку чули одиниці. Сьогодні вона – улюблений аксесуар українських і зарубіжних дизайнерів. Її секрет простий, хоч і має магічний результат. Хочете високі стелі і широкі стіни?",
    "date": "03.09.2024"
  },
  {
    "image": "door-selection",
    "title": "Які двері вибрати для ванної кімнати?",
    "description": "Підхід до вибору дверей у ванну кімнату для багатьох формується виключно з естетичної точки зору. Так, зовнішній вигляд відіграє важливу роль у загальній картині всього інтер'єру. Однак, він не може бути першочерговим у питанні, де технічна складова є найціннішою в даній конструкції.",
    "date": "11.09.2024"
  },
  {
    "image": "aluminum-partitions",
    "title": "Алюміній і скло: нові способи зонування простору",
    "description": "Нові та абсолютно унікальні дизайнерські рейкові перегородки від 1000 мм до 3000 мм зі склом у витонченому алюмінієвому профілі допоможуть вам створити безліч найрізноманітніших сценаріїв освітлення та зонування.",
    "date": "19.09.2024"
  },
  {
    "image": "loft-interior",
    "title": "Як створити настрій Лофт?",
    "description": "Цього літа ми випустили чимало оновлень, щоб надати вам сучасні та актуальні рішення. Сьогодні розповімо, як за допомогою розробок оформити простір у стилі лофт. Дизайнеру на замітку!",
    "date": "26.09.2024"
  }
]
